/**
 * @private
 */
const GeometryType = {
  NONE: 0,
  TRIANGLES: 1,
  LINES: 2,
  POLYLINES: 3
};
export default Object.freeze(GeometryType);